import Dialog from "../../atoms/dialog";
import DatabaseSchemaValidation from "../events/DatabaseSchemaValidation";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { toggleRightDrawer, setReRender } from "../../../store/global/actions";
import { getRightDrawerStatus } from "../../../store/global/selectors";

const DatabaseSchemaValidationAlert = ({messagesList, blueprint, protocol}) => {
    const [open, setOpen] = useState(true)

    const dispatch = useDispatch();
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    


    function updateDisabledMessageAlerts(blueprint, protocol) {
        const key = 'disabledMessageDuplicationAlerts';
      
        // Step 1: Get existing data from localStorage
        const stored = localStorage.getItem(key);
        let alertsArray = [];
      
        try {
          alertsArray = stored ? JSON.parse(stored) : [];
        } catch (e) {
          console.error("Failed to parse disabledMessageAlerts from localStorage", e);
        }
      
        const exists = alertsArray.some(
            (item) => item.blueprint === blueprint && item.protocol === protocol
        );
        
        // Step 3: If not exists, add new object
        if (!exists) {
            alertsArray.push({ blueprint, protocol });
        
            // Step 4: Save updated array to localStorage
            localStorage.setItem(key, JSON.stringify(alertsArray));
        }
      
      }

    const handleClose = () => {
        setOpen(false);
        if(rightDrawerStatus) dispatch(toggleRightDrawer());

        updateDisabledMessageAlerts(blueprint, protocol);

    }


    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            paperProps={{ id: "message_duplication_alert" }}
        >
            <DatabaseSchemaValidation messagesList={messagesList} onClose={handleClose}/>
        </Dialog >
    )
}

export default DatabaseSchemaValidationAlert;